import { makeLocalStorageService } from '../../commons/utils/LocalStorageService'
import { getBaseURL, getAPIKey, getOrigin } from '../../environment'
import { StorageKeys } from '../../models/ILocalStorageService'
import { User } from '../../models/User'
import { UserToken } from '../../models/UserToken'

const baseURL = getBaseURL()
const APIKey = getAPIKey()
const endpoint = '/clients/users'
const origin = getOrigin()

export const getUserByLegacyCode = (
    legacyCode: string
): Promise<User | null> => {
    const { getItem } = makeLocalStorageService()
    const user = getItem(StorageKeys.USERTOKEN) as UserToken

    const queryParams = new URLSearchParams({
        legacyCode,
        millId: user.mill.id,
    })

    return fetch(`${baseURL}${endpoint}?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
            'x-api-key': APIKey,
            'x-origin': origin,
        },
    })
        .then((response: Response) => response.json())
        .then((result) => {
            if (result.data && result.data.length > 0) {
                return result.data[0]
            }
            return null
        })
        .catch((err) => {
            console.error('Erro: ', JSON.stringify(err))
            throw err
        })
}
